<script>
export default {
  props: {
    propertyRow: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getInventories(row) {
      row.inventoryVisible = !row.inventoryVisible;
      if (row.inventoryVisible) {
        row.inventoryLoading = true;
        setTimeout(() => {
          row.inventory = [];
          this.$store
            .dispatch("propertyinventory/GetPropertyInventoryByProperty", row.id)
            .then((res) => {
              row.inventoryLoading = false;
              row.inventory = res.data;
            })
            .catch(() => {
              row.inventoryLoading = false;
              this.showToast("Something went wrong - Getting inventory!", "error");
            });
        }, 1000);
      }
    },
  },
};
</script>

<template>
  <div>
    <b-card-body class="border cursor-pointer" @click="getInventories(propertyRow)">
      <div class="d-flex align-items-center justify-content-between">
        <h6 class="mb-0">
          <i class="bx bx-box"></i>
          Inventory
        </h6>
        <h5 class="mb-0">
          <i
            class="bx bx-chevron-right rotate"
            :class="{
              'rotate-90': propertyRow.inventoryVisible,
            }"
          ></i>
        </h5>
      </div>
    </b-card-body>
    <b-collapse :visible="propertyRow.inventoryVisible" role="tabpanel">
      <b-card-body v-if="propertyRow.inventoryLoading" class="border">
        <div class="d-flex align-items-center justify-content-center">
          <div class="preloader-component me-2">
            <div class="status">
              <div class="spinner-chase w-25px h-25px">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <h5 class="mb-0">Loading...</h5>
        </div>
      </b-card-body>
      <b-card-body v-else-if="propertyRow.inventory.length == 0" class="border">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <p class="mb-0">
            <i>No inventory</i>
          </p>
        </div>
      </b-card-body>
      <b-card-body v-else class="text-muted border">
        <div class="card p-3" v-for="y in propertyRow.inventory" :key="y.id">
          <div>
            <b class="text-white font-size-14">{{ y.title }}</b>
            <div>
              <b v-if="y.status == 'ONGOING'">
                Start Date:
                {{ formatDate(new Date(y.startDate)) }}
              </b>
              <b v-else>
                End Date:
                {{ formatDate(new Date(y.endDate)) }}
              </b>
            </div>
            <div
              class="badge"
              :class="y.status == 'ONGOING' ? 'bg-success' : 'bg-danger'"
            >
              <small class="font-size-10">{{ y.status }}</small>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-collapse>
  </div>
</template>
